import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TicketReminderDTO } from '@sb-tools/typescript/models/dto/ticket-reminder.dto';
import { InlineSVGComponent } from '../../../../sb-modules/Frontend-Inline-SVG-Module/inline-svg.component';
import { TranslateModule } from '@ngx-translate/core';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-reply-reminder-alert',
    templateUrl: './reply-reminder-alert.component.html',
    styleUrls: ['./reply-reminder-alert.component.scss'],
    imports: [InlineSVGComponent, TranslateModule, DatePipe],
})
export class ReplyReminderAlertComponent {
    @Input() reminder: TicketReminderDTO;
    @Output() removeReminderClick: EventEmitter<void> = new EventEmitter();
}
